import React, { Component } from 'react';
import Content from '../../components/Content';
import BgImg from '../../img/BgImg.jpg';
import T from '../../components/translateRender';
import Plan from '../../components/Plan';

export default class extends Component {
  render() {
    return (
      <div>
        <div
          className={'text-left p-5 d-flex align-items-center'}
          style={{
            height: '140vh',
            maxHeight: '26rem',
            background: 'url(' + BgImg + ')'
          }}
        >
          <div className='container'>
            <h5 style={{ color: '#ce1e20' }}>
              <T name='PricingBanner1p' />
            </h5>
            <h1 className='text-white font-weight-bolder mt-5'>
              <T name='PricingBannerHeader' />
            </h1>
          </div>
        </div>
        <Plan />
        <Content />
      </div>
    );
  }
}
